module.exports = __webpack_public_path__ + "img/og_webtoon.20dec377.jpg";